// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__db9B5","carouselWrapper":"styles_carouselWrapper___8_vg","carouselNav":"styles_carouselNav__TGj7I","carouselList":"styles_carouselList__ABy8E"};